module.exports = __webpack_public_path__ + "img/htmlold.86fad85c.svg";